import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import studentPhoto from '../../img/user-profile.png';
import {
    MDBBtn,
    MDBCollapse
} from 'mdb-react-ui-kit';
import Swal from "sweetalert2";
import useCustomDataTableStyles from "../../components/estilosDeDataTable";
import DashboardCard from "../../components/TituloDashboard";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import billingService from "../../services/billingService";
import util from '../../utils/generalFunctions';
import moment from "moment";

const PagosEstudiantepc = () => {
    const studentInfo = util.getStudentInformation();
    const [pagos, setPagos] = useState([]);
    const [obligaciones, setObligaciones] = useState([]);
    const [showObligaciones, setShowObligaciones] = useState(true); // Estado para el collapse

    useEffect(() => {
        fetchEstadoDeCuenta(); // Carga inicial de datos
    }, []);

    // Función para obtener los datos
    const fetchEstadoDeCuenta = async () => {
        try {
            const courseId = studentInfo.courseId;
            const schoolYearId = studentInfo.schoolYearId;
            const educationLevelId = studentInfo.educationLevelId;
            const studentId = studentInfo.studentId;
            const journeyId = studentInfo.journeyId;

            const response = await billingService.getEstadoDeCuentas(studentId, journeyId, schoolYearId, educationLevelId, courseId);
            setObligaciones(response.statusAccount);
            setPagos(response.payments);
        } catch (error) {
            console.error("Error al obtener los datos:", error);
        }
    };

    // Columnas para la DataTable de Obligaciones
    const columnsObligaciones = [
        {
            name: "Fecha",
            sortable: true,
            cell: (row) => (
                <span>
                    {moment(moment(new Date()).format('yyyy') + "-" + row.numero + "-01").format('YYYY-MM-DD')}
                </span>
            ),
        },
        { name: "Concepto", selector: "billingConceptName", sortable: true },
        {
            name: "Monto a pagar",
            selector: "deudaTotal",
            sortable: true,
            cell: (row) => <span>{util.formatNumber.new(row.deudaTotal, "$")}</span>
        },
        {
            name: "Obligación",
            selector: "valuePaidWithDiscount",
            sortable: true,
            cell: (row) => <span>{util.formatNumber.new(row.valuePaidWithDiscount, "$")}</span>
        },
        {
            name: "Interés",
            selector: "interes",
            sortable: true,
            cell: (row) => <span>{util.formatNumber.new(row.mora, "$")}</span>
        },
        {
            name: "Estado",
            sortable: true,
            cell: (row) => (
                <span>
                    {row.deudaTotal > 0 ? (
                        <span className="badge bg-warning">Pendiente</span>
                    ) : (
                        <span className="badge bg-success">Pagado</span>
                    )}
                </span>
            )
        },
    ];

    // Columnas para la DataTable de Pagos
    const columnsPagos = [
        { name: "Fecha", selector: "billingDate", sortable: true },
        { name: "Concepto", selector: "billingConceptName", sortable: true },
        {
            name: "Monto Pagado",
            selector: "total",
            sortable: true,
            cell: (row) => <span>{util.formatNumber.new(row.total, "$")}</span>
        },
    ];

    const customStyles = useCustomDataTableStyles();

    return (
        <div className="observaciones-asistencia-container-pc">
            {/* Botón de navegación */}
            <div className="mb-3">
               <Link to="/dashboard" className="back-to-dashboard-pc">
                               <FontAwesomeIcon icon={faArrowLeft} />
                           </Link> 
            </div>

            {/* Tarjeta de información del estudiante */}
            <DashboardCard
                studentPhoto={studentPhoto}
                title="Historial de Pagos"
                subtitle="Consulta tus pagos y obligaciones"
            />

            {/* Botones de pago */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 botones-pago">
                 {/*
                <div className="mb-2">
                    <a href="https://www.psepagos.co/PSEHostingUI/ShowTicketOffice.aspx?ID=8547" target="blank"
                        className="btn btn-success btn-pago">💳 Pagar con PSE</a>
                    <a href="https://checkout.wompi.co/l/9blBnm" target="blank"
                        className="btn btn-info btn-pago">💳 Tarjeta de Crédito</a>
                </div>
                */}
                <btn className="btn btn-primary btn-toggle-obligaciones" onClick={() => setShowObligaciones(!showObligaciones)}>
                    {showObligaciones ? <FontAwesomeIcon icon={faAngleUp} />  : <FontAwesomeIcon icon={faAngleDown} />}  
                    {showObligaciones ? " Ocultar Obligaciones"   : " Mostrar Obligaciones" } 
                </btn>
            </div>

            {/* Sección de Obligaciones */}
            <MDBCollapse show={showObligaciones}>
                <div className="card mt-3 shadow-sm">
                    <div className="card-body">
                        <DataTable
                            title="Obligaciones de Pago"
                            columns={columnsObligaciones}
                            data={obligaciones}
                            customStyles={customStyles}
                            pagination
                            fixedHeader
                            fixedHeaderScrollHeight="350px"
                        />
                    </div>
                </div>
            </MDBCollapse>

            {/* Historial de Pagos */}
            <div className="card mt-3 shadow-sm">
                <div className="card-body">
                    <DataTable
                        title="Historial de Pagos"
                        columns={columnsPagos}
                        data={pagos}
                        customStyles={customStyles}
                        pagination
                        fixedHeader
                        fixedHeaderScrollHeight="450px"
                    />
                </div>
            </div>

            {/* Estilos personalizados */}
            <style jsx>{`
                .btn-back {
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.9rem;
                }
                .btn-back svg {
                    margin-right: 5px;
                }
                .botones-pago {
                    text-align: center;
                }
                .btn-pago {
                    font-size: 0.85rem;
                    margin: 5px;
                }
                .btn-toggle-obligaciones {
                    font-size: 0.9rem;
                    margin-top: 5px;
                }
                .card {
                    border-radius: 10px;
                }
                @media (max-width: 768px) {
                    .botones-pago {
                        flex-direction: column;
                        align-items: center;
                    }
                    .btn-pago {
                        width: 100%;
                    }
                    .btn-toggle-obligaciones {
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

export default PagosEstudiantepc;
